import { createComponent } from '@front/utils/alpine';
const query = async (route, content, csrfToken) => {
    const response = await fetch(route, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'X-CSRF-TOKEN': csrfToken || '',
        },
        body: content,
    });
    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }
    return response;
};
const HandleBrief = createComponent(() => ({
    //address modal
    isAddressModalOpen: false,
    choice: '',
    //customer modal
    isOpen: false,
    isCustomerModalOpen: false,
    choiceName: '',
    async sendAddress() {
        const app = JSON.parse(document
            .querySelector('meta[name="app"]')
            .getAttribute('content'));
        const addressInput = this.$refs.address;
        const postcodeInput = this.$refs.postcode;
        const cityInput = this.$refs.city;
        const countryInput = this.$refs.country;
        const address = {
            address: addressInput.value,
            postcode: postcodeInput.value,
            city: cityInput.value,
            country: countryInput.value,
        };
        const formData = new FormData();
        formData.append('address', JSON.stringify(address));
        const response = (await query('update/address', formData, app.token));
        const json = await response.json();
        const addressContent = this.$refs.addressContent;
        addressContent.innerHTML = `
            ${json.address.address}<br>
            ${json.address.postcode} ${json.address.city}<br>
            ${json.address.country}
        `;
        this.isAddressModalOpen = false;
    },
    async sendCustomer() {
        const app = JSON.parse(document
            .querySelector('meta[name="app"]')
            .getAttribute('content'));
        const gender = document.querySelector('input[name=gender]:checked');
        const lastnameInput = this.$refs.lastname;
        const firstnameInput = this.$refs.firstname;
        const companyInput = this.$refs.company;
        const phoneInput = this.$refs.phone;
        const emailInput = this.$refs.email;
        const commercialInput = this.$refs.commercialInput;
        const customer = {
            gender: gender.value,
            lastname: lastnameInput.value,
            firstname: firstnameInput.value,
            company: companyInput.value,
            phone: phoneInput.value,
            email: emailInput.value,
            asked_commercial: commercialInput.value,
        };
        const formData = new FormData();
        formData.append('customer', JSON.stringify(customer));
        const response = (await query('update/customer', formData, app.token));
        const json = await response.json();
        const customerContent = this.$refs.customerContent;
        let content = `
            ${json.customer.firstname} ${json.customer.lastname}<br>
            ${json.customer.company}<br>
            ${json.customer.phone}<br>
            ${json.customer.email}<br>
        `;
        if (json.customer.asked_commercial) {
            content += `Votre commercial : ${json.customer.asked_commercial}`;
        }
        customerContent.innerHTML = content;
        this.isCustomerModalOpen = false;
    },
}));
export { HandleBrief };
